module.exports = __webpack_public_path__ + "img/eagleScrn1.af01be5a.png";